//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

/** Type of prize awarded from completing a game group */
export enum GameGroupPrizeType {
	/** Points will be awarded */
	Points = 0,
	/** Prize draw entry will be awarded */
	PrizeDrawEntry = 1
}
